export default __webpack_public_path__ + "static/media/residue_practice_sell.75516455.jpg";